import IComponent from "components/commons/IComponent";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import Button from "@material-ui/core/Button";
import FilterList from "components/commons/FilterList";
import DivTable from "components/commons/DivTable";
import DrawTool from "components/commons/DrawTool";
import geometryTools from "utils/geometryTools";
import IdentifyManager from "components/MapViews/IdentifyManager";
import DownloadFromWebAPI from "utils/DownloadFromWebAPI";
import DownloadBlob from "utils/DownloadBlob";
import "./AerialPhoto.scoped.css";
import Graphic from "@arcgis/core/Graphic";
const CACHED_SEARCH_RESULT = [];
let CACHED_YEAR_DROPDOWN = undefined;
let lyrPhotoPoints = null;
let lyrHighlight = null;
let lastPhotoArray = undefined;
class AerialPhoto extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownAllYear: [],
      dropdownAllHeight: ["ALL", "<=6000", "6000 - 12000", ">=12000"].map(
        (i, j) => ({
          value: j,
          optionName: i,
          checked: false,
        })
      ),
      availYears: [],
      availPhotos: [],
      isLoading: false,
      selPhoto: undefined,
      selPoint: undefined,
      selYears: undefined,
      goToPhotoId: "",
      searchXY: {
        x: 800000,
        y: 800000,
      },
      layer: undefined,
    };
    if (!lyrPhotoPoints) {
      lyrPhotoPoints = new geometryTools.FeatureLayer({
        objectIdField: "objectid",
        geometryType: "point",
        fields: [
          { name: "objectid", type: "oid" },
          { name: "YEAR", type: "string" },
          { name: "PHOTO_NO", type: "string" },
          { name: "EASTING", type: "string" },
          { name: "NORTHING", type: "string" },
          { name: "HEIGHT", type: "string" },
          { name: "X1", type: "string" },
          { name: "X2", type: "string" },
          { name: "Y1", type: "string" },
          { name: "Y2", type: "string" },
          { name: "QUANTITY", type: "string" },
          { name: "REMAIN", type: "string" },
          { name: "FLIGHT_PATH", type: "string" },
          { name: "DUE_DATE", type: "string" },
        ],
        labelingInfo: [
          {
            labelExpressionInfo: { expression: "$feature.PHOTO_NO" },
            symbol: {
              type: "text",
              color: "black",
              haloSize: 2,
              haloColor: "white",
              font: {
                family: "Times New Roman",
                size: 14,
                wieght: "bold",
              },
            },
            labelPlacement: "above-center",
          },
        ],
        source: [],
        spatialReference: props.mapView.spatialReference,
        renderer: {
          type: "simple",
          symbol: geometryTools.highlightSymbol.point,
        },
        title: "Aerial Photo Points",
        popupEnabled: true,
        outFields: "*",
      });
      let vm = this;
      IdentifyManager.addPopupTemplate("Aerial Photo Points", {
        title: "Photo No.: {PHOTO_NO}",
        content: function(feature) {
          let attr = feature.graphic.attributes;
          let content = document.createElement("DIV");
          content.className = "SubPanelContent AutoSize";
          content.innerHTML = [
            `Year: ${attr.YEAR}`,
            `Height: ${attr.HEIGHT}`,
            `Status: ${vm.getStatusText(attr)}`,
            `Due Date: ${attr.DUE_DATE}`,
            "",
            `<a href="${DownloadFromWebAPI([
              "esfsshare1",
              "Aerial_photo/" + attr.FLIGHT_PATH,
            ])}" target="_blank">Flight Path</a>`,
          ].join("<br/>");
          return content;
        },
      });
    }
  }
  componentDidMount() {
    this.getAllYeaList();
    this.props.mapView.map.add(lyrPhotoPoints);
    lyrHighlight = geometryTools.createGraphicsLayerById(
      "LyrAerialPhotoHighlight",
      this.props.mapView.map
    );
  }
  componentWillUnmount() {
    lyrPhotoPoints.applyEdits({
      deleteFeatures: lastPhotoArray,
    });
  }
  async getAllYeaList() {
    if (CACHED_YEAR_DROPDOWN) {
      this.setState({ dropdownAllYear: CACHED_YEAR_DROPDOWN });
      return;
    }
    let yearList = await this.fetchQueryByPOST(
      this.$config.webSrvUrl + "WebAPI/GInfo/AerialPhotoAllYears"
    );
    yearList = await yearList.json();
    let dropdownAllYear = yearList.map((i) => ({
      value: i,
      optionName: i,
      checked: false,
    }));
    dropdownAllYear.splice(0, 0, {
      value: "ALL",
      optionName: "ALL",
      checked: false,
    });
    this.setState({ dropdownAllYear });
    CACHED_YEAR_DROPDOWN = dropdownAllYear;
  }
  searchWithXYInputBox() {
    this.props.showDialog({
      isOpen: true,
      title: "Search by XY",
      content: (
        <div>
          <div>
            <div>Easting</div>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "x",
                  dataType: "text",
                  hint: "Easting",
                },
                row: this.state.searchXY,
              }}
              onChange={(a, v) => {
                this.state.searchXY.x = v;
                this.setState();
              }}
              style={{ height: "40px", boxSizing: "border-box" }}
            />
          </div>
          <div>
            <div>Northing</div>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "y",
                  dataType: "text",
                  hint: "Northing",
                },
                row: this.state.searchXY,
              }}
              onChange={(a, v) => {
                this.state.searchXY.y = v;
                this.setState();
              }}
              style={{ height: "40px", boxSizing: "border-box" }}
            />
          </div>
        </div>
      ),
      onDialogOk: () => {
        let { x, y } = this.state.searchXY;
        if (isNaN(x) || isNaN(y)) {
          this.props.showDialog({
            type: "error",
            isOpen: true,
            title: "Search by XY",
            content: "Invalid input for the coordinate!",
            onDialogOk: () => {
              this.searchWithXYInputBox();
              return false;
            },
          });
          return false;
        }
        x = parseInt(x);
        y = parseInt(y);
        this.searchForPhotos(x, y);
      },
      onDialogCancel: () => {},
    });
  }
  async searchForPhotos(x, y) {
    this.props.mapView.graphics.removeAll();
    lyrPhotoPoints.applyEdits({
      deleteFeatures: lastPhotoArray,
    });
    this.setState({ isLoading: true, availYears: [], availPhotos: [] });
    x = isNaN(x) ? x : x.toFixed(0);
    y = isNaN(y) ? y : y.toFixed(0);
    let results = await this.fetchQueryByPOST(
      this.$config.webSrvUrl + "WebAPI/GInfo/AerialPhotosByParameters",
      {
        Years: this.state.dropdownAllYear
          .reduce((p, c, i) => {
            if (c.checked) p.push(c.value);
            return p;
          }, [])
          .join("|"),
        Heights: this.state.dropdownAllHeight
          .reduce((p, c, i) => {
            if (c.checked) p.push(c.value);
            return p;
          }, [])
          .join("|"),
        Easting: x,
        Northing: y,
      }
    );
    results = await results.json();
    console.debug(results);
    CACHED_SEARCH_RESULT.push({
      x,
      y,
      results,
    });
    this.setState({ isLoading: false, selPoint: [], selYears: [] });
    this.zoomToPoint(x, y);
  }
  async searchForSinglePhots() {
    lyrPhotoPoints.applyEdits({
      deleteFeatures: lastPhotoArray,
    });
    let id = this.state.goToPhotoId;
    let result = await this.fetchQueryByPOST(
      this.$config.webSrvUrl + "WebAPI/GInfo/AerialPhotoByID",
      { Key: id }
    );
    result = await result.json();
    this.addPointToLayer([result]);
    this.zoomToPoint(result.EASTING, result.NORTHING);
  }
  addPointToLayer(availPhotos) {
    availPhotos = availPhotos || this.state.availPhotos;
    let lyrData = availPhotos.map(
      (i, j) =>
        new geometryTools.Graphic({
          attributes: { ...i, objectid: j },
          geometry: new geometryTools.Point({
            x: parseInt(i.EASTING),
            y: parseInt(i.NORTHING),
            spatialReference: this.props.mapView.spatialReference,
          }),
        })
    );
    lyrPhotoPoints.applyEdits({
      addFeatures: lyrData,
      deleteFeatures: lastPhotoArray,
    });
    lastPhotoArray = lyrData;
  }
  async zoomToPoint(x, y, noZoom = false) {
    let geometry = new geometryTools.Point({
      type: "point",
      x,
      y,
      spatialReference: this.props.mapView.spatialReference,
    });
    await this.props.mapView.goTo(geometry);
    const graphic = new Graphic({
      geometry: geometry,
      symbol: {
        type: "simple-marker",
        style: "diamond",
        color: [255, 0, 0],
        size: "8px",
        outline: {
          // Define the outline of the symbol
          color: [255, 0, 0], // White outline
        },
      },
    });
    if (this.state.layer !== undefined) this.state.layer.removeAll();
    await this.props.mapView.graphics.add(graphic);
    if (!noZoom) this.props.mapView.scale = 10000;
  }
  getStatusText(r) {
    return `${r.REMAIN} / ${r.QUANTITY} photo(s) ${
      r.REMAIN === "0" ? `on loan : due date - ${r.DUE_DATE}` : "available"
    }`;
  }
  exportResult() {
    let photos = this.state.availPhotos || [];
    let sb = photos.map(
      (i) =>
        `${i.PHOTO_NO} ( ${i.YEAR} at ${i.HEIGHT} feet) : ${this.getStatusText(
          i
        )}`
    );
    DownloadBlob(sb.join("\r\n"), "data.txt", "text/plain");
  }
  mapUICallback(Layer) {
    //Layer.removeAll();

    this.setState({ layer: Layer });
  }
  render() {
    const { dropdownAllHeight, dropdownAllYear } = this.state;
    return (
      <div className="AerialPhotoUi">
        <div className="PanelTitle">
          <span>Aerial Photo</span>
        </div>
        <div className="PhotoNoPanel EqualWidthChildren SubPanelContent">
          <div>Go to the photo</div>
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "goToPhotoId",
                dataType: "text",
                hint: "Enter Photo ID",
              },
              row: this.state,
            }}
            onChange={(a, v) => {
              this.setState({
                goToPhotoId: v,
              });
            }}
            style={{ height: "40px", boxSizing: "border-box" }}
          />
          <Button
            classes={{ root: "actionBtn" }}
            variant="contained"
            onClick={() => this.searchForSinglePhots()}
            style={{ height: "40px" }}
          >
            <span className="icn_menu_search icon_s" />
          </Button>
        </div>
        <div className="PhotoSearchPanel">
          <div className="SubPanelTitle EqualWidthChildren">
            <div>Search for photos</div>
            <div className="AlignRight">
              <span
                className="ActionBtn icn_3d_Elevationprofile_export"
                onClick={() => this.exportResult()}
              />
            </div>
          </div>
          <div className="SubPanelContent">
            <div className="EqualWidthChildren AlignCentre">
              <div>Year</div>
              <div>Height</div>
            </div>
            <div className="EqualWidthChildren">
              <FilterList
                listData={dropdownAllYear}
                noFilterBox={true}
                height={140}
                compact={true}
                onChange={() => this.setState({})}
              />
              <FilterList
                listData={dropdownAllHeight}
                noFilterBox={true}
                height={140}
                compact={true}
                onChange={() => this.setState({})}
              />
            </div>
            <div
              className={`EqualWidthChildren ${
                dropdownAllHeight.filter((i) => i.checked).length === 0 ||
                dropdownAllYear.filter((i) => i.checked).length === 0
                  ? "Disable"
                  : ""
              }`}
            >
              <div>
                <DrawTool
                  mapView={this.props.mapView}
                  onDrawComplete={(geometry) => {
                    if (!!geometry) {
                      this.searchForPhotos(geometry.x, geometry.y);
                    }
                  }}
                  excludedList={{ text: 1, polyline: 1, polygon: 1 }}
                  AerialPhoto={true}
                  mapUICallback={this.mapUICallback.bind(this)}
                />
              </div>
              <Button
                classes={{ root: "actionBtn" }}
                variant="contained"
                onClick={() => this.searchWithXYInputBox()}
                style={{ height: "50px", width: "100%", flexShrink: 2 }}
              >
                <span className="icn_menu_search icon_s" /> By XY
              </Button>
            </div>
          </div>
          <div className="ResultTables SubPanelContent">
            <div>
              <DivTable
                selectedRow={this.state.selPoint}
                data={this.state.isLoading ? [] : CACHED_SEARCH_RESULT}
                columnDef={[
                  { name: "Easting", value: "x" },
                  { name: "Northing", value: "y" },
                ]}
                actionColumn={[
                  {
                    className: "icn_graphicsearch_delete icon_s",
                    onClick: (r, i) => {
                      CACHED_SEARCH_RESULT.splice(i, 1);
                      this.setState(
                        {
                          availYears: [],
                          availPhotos: [],
                          selPoint: [],
                          selYears: [],
                        },
                        () => this.addPointToLayer()
                      );
                      this.props.mapView.graphics.removeAll();
                    },
                  },
                ]}
                onRowClick={(r, i) => {
                  this.props.mapView.graphics.removeAll();
                  this.zoomToPoint(r.x, r.y);
                  this.setState({
                    availYears: r.results,
                    availPhotos: [],
                    selPoint: [i],
                    selYears: [],
                    selPhoto: undefined,
                  });
                }}
                noDataText={
                  this.state.isLoading ? (
                    <div>
                      <span className="icn_loading" />
                      Querying for aerial photo, please wait...
                    </div>
                  ) : (
                    undefined
                  )
                }
              />
            </div>
            <div>
              <DivTable
                selectedRow={this.state.selYears}
                data={this.state.availYears}
                columnDef={[
                  { name: "Year", value: "YEAR" },
                  {
                    name: "Count",
                    value: "AERIAL_PHOTOs",
                    format: (v, r) => v.length,
                  },
                ]}
                onRowClick={(r, i) => {
                  let selectedIndex = this.state.selYears.findIndex(
                    (m) => m === i
                  );
                  if (selectedIndex !== -1)
                    this.state.selYears.splice(selectedIndex, 1);
                  else this.state.selYears.push(i);
                  let photos = this.state.selYears.map(
                    (i) => this.state.availYears[i].AERIAL_PHOTOs
                  );
                  photos = photos.flat();
                  this.setState(
                    {
                      availPhotos: photos,
                      selYears: this.state.selYears,
                      selPhoto: undefined,
                    },
                    () => this.addPointToLayer()
                  );
                }}
              />
            </div>
            <div>
              <DivTable
                data={this.state.availPhotos}
                columnDef={[
                  { name: "Photo", value: "PHOTO_NO" },
                  { name: "Year", value: "YEAR" },
                  { name: "Height", value: "HEIGHT" },
                  {
                    name: "Status",
                    value: "REMAIN",
                    format: (v, r) => this.getStatusText(r),
                  },
                ]}
                selectedRow={[this.state.selPhoto]}
                onRowClick={(r, i) => {
                  this.zoomToPoint(r.EASTING, r.NORTHING, true);
                  this.setState({
                    selPhoto: i,
                  });
                }}
                onRowMouseOver={async (r, i) => {
                  lyrHighlight?.removeAll();
                  let highlightGraphic = lastPhotoArray[i].clone();
                  let symbol = { ...geometryTools.highlightSymbol.point };
                  symbol.color = [255, 0, 0, 1];
                  highlightGraphic.symbol = symbol;
                  geometryTools.flashSymbol(
                    lyrHighlight,
                    highlightGraphic,
                    (g, v) => (g.symbol.outline.width = 5 * v + 1)
                  );
                }}
                onRowMouseOut={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AerialPhoto;
